// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ColorController from "./color_controller"
application.register("color", ColorController)

import CopyCheckmarkController from "./copy_checkmark_controller"
application.register("copy-checkmark", CopyCheckmarkController)

import DelayFieldsController from "./delay_fields_controller"
application.register("delay-fields", DelayFieldsController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InboxController from "./inbox_controller"
application.register("inbox", InboxController)

import PrefillEmailController from "./prefill_email_controller"
application.register("prefill-email", PrefillEmailController)

import ReviewVisibilityController from "./review_visibility_controller"
application.register("review-visibility", ReviewVisibilityController)

import TriggerToggleController from "./trigger_toggle_controller"
application.register("trigger-toggle", TriggerToggleController)

import ScheduleFieldsController from "./schedule_fields_controller"
application.register("schedule-fields", ScheduleFieldsController)
